<template>
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group @reset="$gjReset" @query="$gjNoticeQuery">
        <gj-country-server-select
          v-model="filter.countryMarketValue"
          :width="['130px', '160px']"
        ></gj-country-server-select>

        <gj-select
          v-model="filter.invoiceType"
          placeholder="全部发票类型"
          :options="invoiceTypesOptions"
          width="155px"
        ></gj-select>

        <gj-select
          v-model="filter.status"
          placeholder="全部发票状态"
          :options="invoiceUploadStatusOptions"
          width="155px"
        ></gj-select>

        <gj-select-date-picker
          v-model="filter.date"
          :options="[{ id: 0, text: '发货时间' },
                     { id: 1, text: '订购时间' },
                     { id: 2, text: '上传时间' }]"
          type="daterange"
          :width="clientWidth > 1366 ? ['120px', '200px'] : ['120px', '100px']"
        ></gj-select-date-picker>

        <gj-select-input
          v-model="filter.keyword"
          :selectDisabled="true"
          :options="[
            {id: 'orderIdList', text: '订单编号', moreShow: true}
          ]"
          :width="clientWidth > 1366 ? ['120px', '200px'] : ['120px', '100px']"
        ></gj-select-input>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-button type="primary" :loading="uploadLoading" @click="upload(selectedRows)">上传发票</gj-button>
    </template>
    <template #tool-group>
      <gj-tool-group
        reset @reset="$emit('query')"
        help
        helpName="vatmanage"
      >
      <template #before>
        <gj-button @click="vatManage">VAT管理</gj-button>
      </template>
      </gj-tool-group>
    </template>
    <template #table>
      <div v-if="!firstHasDate">
        <div v-loading="loading" v-show="showTip" class="table-empty">
          <div class="weight600">当前无发票上传，以下原因可供参考：</div>
          <div>1.店铺未开通VCS lite服务，无法在系统中上传发票/收据，您可以到<span class="empty-link" @click="vatManage">系统->参数设置->VAT管理</span>中维护VCS功能</div>
          <div>2.已开通VCS lite服务，系统暂未获取到发票信息，请稍后再查看</div>
        </div>
      </div>
      <gj-table
        v-show="firstHasDate"
        ref="gjTable"
        :index="false"
        show-overflow
        :loading="loading"
        :data="tableData"
        :columns="columns"
        :pagination="pagination"
        selection
        adapt-parent
        :default-sort="{ prop: 'shipmentDate', order: 'descending' }"
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery">
        <template v-slot:status="{ row }">
          <gj-tooltip
            v-if="row.status === 'fail'"
            style="display: inline-flex;">
            <template #content>
              <i v-if="row.status === 'fail'" class="el-icon-warning colorRed gj-mr5"></i>{{row.failMsg | defaultShow}}
            </template>
            <span class="colorRed"><i v-if="row.status === 'fail'" class="el-icon-warning colorRed"></i>{{ row.status | optionText(invoiceUploadStatusOptions) | defaultShow}}</span>
          </gj-tooltip>
          <span :class="{ 'colorOrange' : row.status === 'wait' }" v-else>{{ row.status | optionText(invoiceUploadStatusOptions) | defaultShow}}</span>
        </template>
        <template v-slot:op="{row}">
          <gj-button v-if="row.status === 'wait' || row.status === 'fail'" :loading="row.uploadLoading" type="text" @click="upload([row], row)">上传发票</gj-button>
          <gj-button v-if="row.status === 'success'" :loading="row.downloadLoading" type="text" @click="download(row)">下载发票</gj-button>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
import { invoiceTypesOptions, invoiceUploadStatusOptions } from "@/utils/options";
import { isMeaningfulMixin, queryMixin, selectionMixin } from "@/minxins";
import {mapGetters} from "vuex";
import { uploadVat, vatUploadRecordList } from "@/api/vat";
import { convertToDate } from "@/utils/date.util";
import { exportFile } from "@/api/common";
export default {
  name: "upload-record",
  mixins: [queryMixin, selectionMixin, isMeaningfulMixin],
  computed: {
    ...mapGetters({
      marketOption: 'marketOption'
    }),
  },
  created() {
    this.sort.prop = 'shipmentDate';
  },
  data() {
    return {
      filter: {
        countryMarketValue: {},
        invoiceType: null,
        status: null,
        date: {
          key: 0,
          value: ''
        },
        keyword: {
          key: 'orderIdList',
          value: null,
          popover: false
        },
      },
      invoiceTypesOptions,
      invoiceUploadStatusOptions,
      columns: [
        {id: 'marketId', header: '店铺/国家', field: 'option:marketId', minWidth: '120px', fixed: 'left', options: () => this.marketOption},
        {id: 'orderId', header: '订单编号', field: 'orderId', minWidth: '180px', fixed: 'left',},
        {id: 'purchaseDate', header: '订购时间', field: 'purchaseDate', minWidth: '180px', default: true, sortable: true },
        {id: 'shipmentId', header: '发货单号', field: 'shipmentId', minWidth: '140px', default: true, align: 'left'},
        {id: 'shipmentDate', header: '发货时间', field: 'shipmentDate', minWidth: '180px', default: true, sortable: true},
        {id: 'invoiceType', header: '发票类型', field: 'option:invoiceType', minWidth: '100px', default: true, align: 'left', options: () => this.invoiceTypesOptions},
        {id: 'invoiceNumber', header: '发票号', field: 'invoiceNumber', minWidth: '240px', default: true, align: 'left'},
        {id: 'status', header: '发票状态', field: 'slot:status', minWidth: '120px', default: true,},
        {id: 'uploadDate', header: '上传时间', field: 'uploadDate', minWidth: '140px', default: true, sortable: true},
        {id: 'op', header: '操作', field: 'slot:op', width: '150px', fixed: 'right', notCustomColumn: true, disabled: true}
      ],
      firstHasDate: false,
      showTip: false,
      tableData: [],
      uploadLoading: false
    };
  },
  methods: {
    // 跳转到vat管理页
    vatManage() {
      this.$router.push({
        path:'/setting/argument',
        query: {
          activeTab: 'vatManage'
        }
      })
    },
    $gjQuery() {
      this.loading = true;
      const params = {
        model: {
          invoiceType: this.filter.invoiceType,
          status: this.filter.status
        },
        ...this.queryPagination,
        ...this.querySort,
      };
      if (this.filter.keyword.value) {
        params.model[this.filter.keyword.key] = this.filter.keyword.value.split(',');
      }
      if (this.isMeaningful(this.filter.countryMarketValue)) {
        params.model.marketList = this.filter.countryMarketValue.marketIds;
        params.model.countryCodes = this.filter.countryMarketValue.countryIds;
      }
      if (this.isMeaningful(this.filter.date.value)) {
        params.model.dateType = this.filter.date.key;
        params.model.beginDate = convertToDate(this.filter.date.value[0]);
        params.model.endDate = convertToDate(this.filter.date.value[1]);
      }
      vatUploadRecordList(params)
        .then((res) => {
          let data = res.data
          data.records.forEach(item => {
            item.uploadLoading = false;
            item.downloadLoading = false;
          })
          this.tableData = data.records || [];
          if(!this.isfirst) {
            this.isfirst = true
            this.firstHasDate = this.tableData.length > 0
          }else if (this.isfirst && this.firstHasDate === false) {
            this.firstHasDate = this.tableData.length > 0
          }
          this.showTip = true
          this.pagination = this.getPagination(data);
        })
        .complete(() => (this.loading = false));
    },
    // 每次新打开页面时，初始化页面参数
    // 若路由中传入了查询参数timeStamp，则填入，并记录
    $gjQueryInitParams() {
      return {
        filter: {
          countryMarketValue: {},
          invoiceType: null,
          status: null,
          date: {
            key: 0,
            value: ''
          },
          keyword: {
            key: 'orderIdList',
            value: null,
            popover: false
          },
        },
      };
    },
    // 下载发票
    download (row) {
      // 下载
      row.downloadLoading = true
      exportFile(`/file/attachment/getDownloadUserDefinedFileName`, [row.attachmentId])
        .complete(()=> {
          row.downloadLoading = false
        })
    },
    upload (rows, row = null) {
      if (rows.length === 0) {
        this.$message.error('请选择需要上传的发票')
        return
      }
      let uploadArr = rows.filter(item => item.status === 'wait' || item.status === 'fail')
      if (uploadArr.length == 0) {
        this.$message.error('当前选中的数据暂无可上传的发票')
      } else {
        if(this.isMeaningful(row)) {
          row.uploadLoading = true;
        } else {
          this.uploadLoading = true;
        }
        // 上传
        let list = []
        uploadArr.forEach(item => list.push({ marketId: item.marketId, orderId: item.orderId, shippingId: item.shippingId, transactionId: item.transactionId }))
        uploadVat(list).then(res => {
          this.$gjMessage.success('上传成功');
          this.$emit('query')
        }).complete(() => {
          if(this.isMeaningful(row)) {
            row.uploadLoading = false;
          } else {
            this.uploadLoading = false;
          }
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.gj-mr5 {
  margin-right: 5px;
}
.table-empty {
  width: 610px;
  margin: 0 auto;
  margin-top: 100px;
  text-align: left;
  font-size: 12px;
  line-height: 30px;
  color: #333333;
  .empty-link {
    cursor: pointer;
    color: #1F6EEF;
  }
  .text-indent-1 {
    text-indent: 1em
  }
}
</style>